var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "pl-10 pr-10 pt-20 bg-white l-t shadow-light" },
      [
        _c(
          "el-form",
          {
            ref: "form",
            staticClass: "filter-from text-center",
            attrs: { inline: true, size: "small" },
          },
          [
            _c(
              "el-form-item",
              { staticClass: "flex1" },
              [
                _c(
                  "el-select",
                  {
                    on: { change: _vm.selUser },
                    model: {
                      value: _vm.user_type,
                      callback: function ($$v) {
                        _vm.user_type = $$v
                      },
                      expression: "user_type",
                    },
                  },
                  [
                    _c("el-option", {
                      attrs: { label: "新增用户数", value: "0" },
                    }),
                    _vm._v(" "),
                    _c("el-option", {
                      attrs: { label: "活跃用户数", value: "1" },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              { staticClass: "flex1" },
              [
                _c(
                  "el-select",
                  {
                    on: { change: _vm.selTime },
                    model: {
                      value: _vm.date_type,
                      callback: function ($$v) {
                        _vm.date_type = $$v
                      },
                      expression: "date_type",
                    },
                  },
                  [
                    _c("el-option", {
                      attrs: { label: "最近7天", value: "0" },
                    }),
                    _vm._v(" "),
                    _c("el-option", { attrs: { label: "昨天", value: "2" } }),
                    _vm._v(" "),
                    _c("el-option", {
                      attrs: { label: "最近30天", value: "1" },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "p-20" }, [
      _c(
        "div",
        { staticClass: "mb-20 bg-white shadow-light" },
        [
          _c("div", { staticClass: "p-15 l-b" }, [_vm._v("性别及年龄分布")]),
          _vm._v(" "),
          _c(
            "el-row",
            [
              _c("el-col", { attrs: { md: { span: 24 }, lg: { span: 12 } } }, [
                _c("div", {
                  staticStyle: { height: "400px" },
                  attrs: { id: "genderEChart" },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "pb-15 text-center" }, [
                  _vm._v("性别分布"),
                ]),
              ]),
              _vm._v(" "),
              _c("el-col", { attrs: { md: { span: 24 }, lg: { span: 12 } } }, [
                _c("div", {
                  staticStyle: { height: "400px" },
                  attrs: { id: "ageEChart" },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "pb-15 text-center" }, [
                  _vm._v("年龄分布"),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mb-20 bg-white shadow-light" },
        [
          _c("div", { staticClass: "p-15 l-b" }, [_vm._v("地区分布")]),
          _vm._v(" "),
          _c(
            "el-row",
            [
              _c("el-col", { attrs: { md: { span: 24 }, lg: { span: 12 } } }, [
                _c("div", {
                  staticStyle: { height: "500px" },
                  attrs: { id: "mapEChart" },
                }),
              ]),
              _vm._v(" "),
              _c(
                "el-col",
                {
                  staticClass: "p-10",
                  attrs: { md: { span: 24 }, lg: { span: 12 } },
                },
                [
                  _c(
                    "el-table",
                    {
                      staticStyle: { border: "1px solid #ebebeb" },
                      attrs: {
                        data: _vm.visit_uv_current.province,
                        "max-height": "500",
                        "header-cell-style": { background: "#f5f7fa" },
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { label: "省份", width: "150" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(scope.row.name) +
                                    "\n              "
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "用户数" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "flex align-center" },
                                  [
                                    _c("div", { staticClass: "map-uv_num" }, [
                                      _vm._v(_vm._s(scope.row.value)),
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "flex1" }, [
                                      _c("div", {
                                        staticClass: "map-uv_p",
                                        style: {
                                          width:
                                            (scope.row.value /
                                              _vm.uv_total[_vm.user_type]
                                                .province_uv) *
                                              100 +
                                            "%",
                                        },
                                      }),
                                    ]),
                                  ]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "p-20" },
            [
              _c(
                "el-table",
                {
                  staticStyle: { border: "1px solid #ebebeb" },
                  attrs: {
                    data: _vm.visit_uv_current.city,
                    "max-height": "500",
                    "header-cell-style": { background: "#f5f7fa" },
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "城市", width: "150" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n              " +
                                _vm._s(scope.row.name) +
                                "\n            "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "用户数" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", { staticClass: "flex align-center" }, [
                              _c("div", { staticClass: "map-uv_num" }, [
                                _vm._v(_vm._s(scope.row.value)),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "flex1" }, [
                                _c("div", {
                                  staticClass: "map-uv_p",
                                  style: {
                                    width:
                                      (scope.row.value /
                                        _vm.uv_total[_vm.user_type].city_uv) *
                                        100 +
                                      "%",
                                  },
                                }),
                              ]),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mb-20 bg-white shadow-light" },
        [
          _c("div", { staticClass: "p-15 l-b" }, [_vm._v("终端与机型分布")]),
          _vm._v(" "),
          _c(
            "el-row",
            [
              _c("el-col", { attrs: { md: { span: 24 }, lg: { span: 12 } } }, [
                _c("div", {
                  staticStyle: { height: "400px" },
                  attrs: { id: "platformsEChart" },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "pb-15 text-center" }, [
                  _vm._v("终端"),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "el-col",
                {
                  staticClass: "p-10",
                  attrs: { md: { span: 24 }, lg: { span: 12 } },
                },
                [
                  _c("div", {
                    staticStyle: { height: "400px" },
                    attrs: { id: "devicesEChart" },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "pb-15 text-center" }, [
                    _vm._v("机型"),
                  ]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }